import React, { useState } from 'react';
import { AccordionItem, Box, Inscription, Preloader } from '@common-fe/common-fe';
import styled from 'styled-components';

import useTiersModule from '@/modules/deductibles/HealthPlanDetails/hooks/useTiersModule.ts';
import { getTriggerName } from '@/modules/deductibles/HealthPlanDetails/TierBlock/TierBlock.tsx';
import { TriggerAmount } from '@/modules/deductibles/HealthPlanDetails/TierBlock/TriggerAmount.tsx';

interface StyledBoxProps {
  isPageMode?: boolean;
}

export const StyledBox = styled(Box)<StyledBoxProps>`
  transition: all 0.15s;
  span {
    transition: all 0.15s;
  }
  a {
    height: 24px;
  }
`;

export const TiersModule: React.FC = () => {
  const { rule, triggerAmounts, isLoadingAll } = useTiersModule();

  const [expandedArr, setExpandedArr] = useState<boolean[]>(rule?.tiers?.map(() => false) || []);

  const handleAccordionChange = (idx: number) => {
    setExpandedArr((prev) => prev.map((val, i) => (i === idx ? !val : val)));
  };

  if (isLoadingAll) {
    return <Preloader />;
  }
  return (
    <Box gap="xs" data-testId="tiers-details">
      {rule?.tiers?.map((item, index) => (
        <Box
          key={item?.id}
          onClick={() => handleAccordionChange(index)}
          pad="m"
          border={{ color: 'border2', size: 'small' }}
          round="container1Round"
          background="canvas"
        >
          <AccordionItem
            key={item?.id}
            onChange={() => handleAccordionChange(index)}
            testId={`tier-accordion-item-${index}`}
            iconSize="24px"
            isExpanded={expandedArr[index]}
            text={
              <Box direction="row" align="center">
                <Inscription margin={{ left: 'xs' }} color="textBody" weight="bold" lineHeight="20px">
                  {index === rule?.tiers.length - 1
                    ? item?.name || ''
                    : `${item?.name || ''} to ${rule?.tiers[index + 1]?.name || ''}`}
                </Inscription>
              </Box>
            }
            isLeftArrow
          >
            {item?.tierTriggers?.length ? (
              <Box background="module" pad="s" round="container1Round" gap="xs" margin={{ top: 'xs' }}>
                {item?.tierTriggers?.map((trigger) => (
                  <TriggerAmount
                    key={trigger.id}
                    isModalView
                    triggerName={getTriggerName(trigger.triggerCategoryType)}
                    triggerAmount={triggerAmounts[trigger.id ?? ''] || 0}
                  />
                ))}
              </Box>
            ) : (
              <Box background="module" pad="s" round="container1Round" gap="xs" margin={{ top: 'xs' }}>
                <TriggerAmount isModalView />
              </Box>
            )}
          </AccordionItem>
        </Box>
      ))}
    </Box>
  );
};
